import React, {memo, ReactNode, useCallback} from 'react';
import {ControlModel, ControlTypeModel} from '../../../types/control';
import {useRPC} from '../../../hooks/rpc';
import {RangeComponent} from '../../Range/RangeComponent';
import { useMessage } from '../../../hooks/message';
import { useApproving } from '../../../hooks/approving';
import { useDispatch, useSelector } from 'react-redux';
import { passwordCheckingTimeoutAction } from '../../../store/ui/actions';

type Props = {
    control: ControlModel
    controlType: ControlTypeModel;
    children?: ReactNode;
};

export const DimmerControl = memo(function DimmerControl(props: Props) {
    const {control, children, controlType} = props;
    const {failure} = useMessage();
    const [rpc] = useRPC();
    const approving = useApproving()
    const passwordTimeoutSycle = useSelector(state => state.ui.passwordTimeoutSycle)
    const dispatch = useDispatch();

    const openAreYouSure = useCallback(
        value => {
            approving(() => {
                dispatch(passwordCheckingTimeoutAction(true))
                rpc.updateControlValue(control.id, value).catch(failure)
            })
        },
        [control, approving, failure, dispatch, rpc]
    )

    const onChange = useCallback(
        (value: number) => {
            if (control?.parameters?.["password_control"] && !passwordTimeoutSycle) {
                openAreYouSure(value)
                return
            }
            rpc.updateControlValue(control.id, value).catch(failure)
        },
        [rpc, control, failure, openAreYouSure, passwordTimeoutSycle]
    )


    return (
        <RangeComponent
            name={control.name}
            value={control.current_value}
            onChange={onChange}
            activeImage={controlType.image_set.active}
            passiveImage={controlType.image_set.passive}>
            {children}
        </RangeComponent>
    );
});
